import { render, staticRenderFns } from "./materialLineNomenklatura.vue?vue&type=template&id=5e13c8f1&scoped=true&"
import script from "./materialLineNomenklatura.vue?vue&type=script&lang=js&"
export * from "./materialLineNomenklatura.vue?vue&type=script&lang=js&"
import style0 from "./materialLineNomenklatura.vue?vue&type=style&index=0&id=5e13c8f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13c8f1",
  null
  
)

export default component.exports